import Api from './Api';

let loading = false;
let updating = false;

function load() {
  return async function (dispatch) {
    if (loading) { return; }
    loading = true;
    let database = [];
    database = await Api.getAll();
    dispatch({ type: 'LOAD_PLAYERS_SUCCESS', database });
    loading = false;
    return database;
  };
}

function update(local) {
  return async function (dispatch) {
    if (updating) { return local; }
    updating = true;
    const changedEntries = local.filter((entry) =>
      entry.update || entry.deleted,
    );
    const database = await Api.update(changedEntries);
    dispatch({ type: 'UPDATE_PLAYERS_SUCCESS', database });
    updating = false;
    return database;
  };
}

function add(firstName, lastName) {
  return async function (dispatch) {
    const newEntry = await Api.add(firstName, lastName);
    dispatch({ type: 'ADD_PLAYER_SUCCESS', newEntry });
    return newEntry;
  };
}

const actions = { load, update, add };
export default actions;
